package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.core.unsplash.ui.UnsplashImage
import com.essntl.core.unsplash.ui.UnsplashPopup
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.file.ui.essntlgallery.EssntlGallery
import com.essntl.uikit.components.file.FileViewer
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalValidation
import com.essntl.uikit.components.button.secondary.EsMediumSecondaryButton
import com.essntl.uikit.components.button.tinted.EsMediumTintedButton
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.input.date.EsDateInput
import com.essntl.uikit.components.input.date.EsDateRangeInput
import com.essntl.uikit.components.input.label.EsInputLabel
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Text
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.components.ContactDropdownType
import com.essntl.features.contact.ui.components.ContactsDropDown
import com.essntl.features.file.ui.essntlgallery.EssntlGalleryState
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalNavigation
import com.essntl.features.proposal.ui.rememberCommissionIntSum
import com.essntl.features.proposal.ui.rememberPriceIntSum
import com.essntl.uikit.components.checkbox.EsPrimaryCheckBox
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.core.LocalPlatformContext
import core.config.CurrencyConfig
import core.dateformat.ui.formatDate

@Composable
fun BaseInformation(
    state: AddEditProposalState,
    onEvent: (AddEditProposalEvent) -> Unit,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    onNavigation: (AddEditProposalNavigation) -> Unit,
    isEdit: Boolean,
    proposal: ProposalModel,
    selectedAreaList: List<AreaModel>,
    validation: AddEditProposalValidation,
    onProposalChange: (ProposalModel) -> Unit,
) {
    var editable by rememberSaveable { mutableStateOf(!isEdit) }

    val context = LocalPlatformContext.current

    var openUnsplashDialog by rememberSaveable { mutableStateOf(false) }
    var openEssntlGalleryDialog by rememberSaveable { mutableStateOf(false) }

    var fileUrl by rememberSaveable { mutableStateOf("") }
    var isFileViewerOpened by rememberSaveable { mutableStateOf(false) }

    val fromDate = proposal.fromDate.orEmpty().formatDate()
    val toDate = proposal.toDate.orEmpty().formatDate()

    val filteredProposalServices = state.filteredProposalServices

    val priceIntSum = rememberPriceIntSum(filteredProposalServices,state.getAllProposalServicesPrices.data.orEmpty())

    val commissionIntSum = rememberCommissionIntSum(
        proposal = proposal,
        proposalServiceList = filteredProposalServices,
    )

    LaunchedEffect(state.addEditProposal.isSuccess) {
        if (state.addEditProposal.isSuccess) {
            if (state.addEditProposal.data?.status == ProposalModel.Status.Confirmed)
                onNavigation(AddEditProposalNavigation.ClosePanel)

            editable = false
            onEvent(AddEditProposalEvent.ClearSuccessState)
        }
    }

    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start,
        modifier =
            Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                .then(
                    if (editable)
                        Modifier.background(MaterialTheme.esColorScheme.bgSecondary) else
                        Modifier,
                )
                .padding(
                    vertical = EsConstants.SectionVerticalPadding,
                    horizontal = EsConstants.SectionHorizontalPadding,
                ),
    ) {
        if (editable)
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.Start,
                modifier = Modifier.fillMaxWidth(),
            ) {
                if (isEdit) {
                    Box(
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Row(
                            modifier = Modifier
                                .align(Alignment.TopEnd)
                                .clip(RoundedCornerShape(2.spacing))
                                .clickable {
                                    editable = !editable
                                }
                                .padding(1.spacing),
                        ) {
                            Text(
                                text = "Cancel",
                                textAlign = TextAlign.Start,
                                style = MaterialTheme.esTypography.p1Medium16,
                                color = MaterialTheme.esColorScheme.textError,
                            )

                            EsLargeIcon(
                                res = EsIcons.Close,
                                tint = MaterialTheme.esColorScheme.iconError,
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(2.spacing))
                }

                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(2.spacing),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Box(
                        modifier = Modifier.fillMaxWidth(0.4f),
                    ) {
                        ContactsDropDown(
                            state = contactState,
                            onEvent = contactEvent,
                            type = ContactDropdownType.AGENCY,
                            selectedContact = proposal.travelAgent?.id,
                            defaultText = proposal.travelAgent?.prettyNameOrganization,
                            enabled = state.isEnabled,
                            label = "Travel Agent",
                            placeholder = "Select Travel Agent",
                            onItemSelected = { id ->
                                if (proposal.travelAgent?.id == id) return@ContactsDropDown

                                onEvent(
                                    AddEditProposalEvent.UpdateProposalTravelAgent(
                                        travelAgentId = id,
                                    ),
                                )
                            },
                            createNew = true,
                            onCreateNew = { onNavigation(AddEditProposalNavigation.AddTravelAgent) },
                        )
                    }

                    EsDateInput(
                        value = proposal.requestReceivedDate.orEmpty(),
                        onValueChange = {
                            onEvent(
                                AddEditProposalEvent.UpdateProposalFields(
                                    proposal.copy(requestReceivedDate = (it)),
                                ),
                            )
                        },
                        message = "",
                        label = "Request Received",
                        enabled = !state.addEditProposal.isLoading && state.isEnabled,
                        modifier = Modifier.fillMaxWidth(0.5f),
                    )

                    EsInput(
                        value = proposal.commission
                            ?.let { if (it > 0) "$it" else "" }
                            .orEmpty(),
                        placeholder = "Commission %",
                        label = "Enter the commission %",
                        enabled = !state.addEditProposal.isLoading && state.isEnabled,
                        onValueChange = {
                            val commission: Number = it.toDoubleOrNull() ?: 0
                            onProposalChange(
                                proposal.copy(
                                    commission = commission.toDouble(),
                                ),
                            )
                        },
                        keyboardOptions =
                            KeyboardOptions(
                                keyboardType = KeyboardType.Number,
                            ),
                        message = "",
                        modifier = Modifier.fillMaxWidth(),
                    )
                }

                Spacer(modifier = Modifier.height(3.spacing))

                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(2.spacing),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    EsInput(
                        value = proposal.title ?: "",
                        onValueChange = {
                            validation.addEditProposalForm.title.validate(it)
                            onProposalChange(proposal.copy(title = it))
                        },
                        label = "Title",
                        placeholder = "Enter title",
                        message = "This field is required",
                        state = validation.addEditProposalForm.title.state,
                        enabled = state.isEnabled,
                        modifier = Modifier.fillMaxWidth(0.5f),
                    )

                    EsInput(
                        value = proposal.headline ?: "",
                        onValueChange = {
                            onProposalChange(proposal.copy(headline = it))
                        },
                        label = "Internal Proposal Details",
                        placeholder = "Enter internal notes here (not visible to the client)",
                        singleLine = false,
                        message = "",
                        enabled = state.isEnabled,
                        modifier = Modifier.fillMaxWidth(),
                    )
                }

                Spacer(modifier = Modifier.height(2.spacing))

                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(2.spacing),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Box(
                        modifier = Modifier.fillMaxWidth(0.2f),
                    ) {
                        EsInputDropdownMenu(
                            items = state.getAllArea.data.orEmpty(),
                            selectedItems = selectedAreaList,
                            text = { it.name ?: "" },
                            onItemsChanged = { areas ->
                                validation.addEditProposalForm.areas.validate(areas.map { it.id })
                                onProposalChange(
                                    proposal.copy(
                                        areas = areas.map { it.id },
                                    ),
                                )
                            },
                            label = "Area",
                            placeholder = "Select Area",
                            message = "This field is required",
                            state = validation.addEditProposalForm.areas.state,
                            enabled = state.isEnabled,
                        )
                    }

                    EsDateRangeInput(
                        value = if (proposal.fromDate.isNullOrEmpty() && proposal.toDate.isNullOrEmpty())
                            "" else
                            "${fromDate}-${toDate}",
                        onValueChange = {},
                        readOnly = true,
                        fromDate = proposal.fromDate.orEmpty(),
                        toDate = proposal.toDate.orEmpty(),
                        onDateRangeChange = { from, to ->
                            validation.addEditProposalForm.dateRange.validate(from, to)

                            onProposalChange(
                                proposal.copy(
                                    fromDate = if (from.isNotEmpty()) (from) else null,
                                    toDate = if (to.isNotEmpty()) (to) else null,
                                ),
                            )

                            if (from.isNotEmpty() &&
                                to.isNotEmpty()
                                && isEdit
                            )
                                onEvent(
                                    AddEditProposalEvent.UpdateProposalDates(
                                        proposal.id,
                                        from,
                                        context,
                                    ),
                                )
                        },
                        label = "Dates",
                        state = validation.addEditProposalForm.dateRange.firstState,
                        message = "This field is required",
                        enabled = state.isEnabled,
                        modifier = Modifier.fillMaxWidth(0.25f),
                    )

                    Spacer(modifier = Modifier.height(2.spacing))

                    val hidePricesEnabled = state.isEnabled &&
                        (proposal.showsTotalOnly == null || proposal.showsTotalOnly == false)

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        EsPrimaryCheckBox(
                            checked = proposal.hidePrices ?: false,
                            enabled = hidePricesEnabled,
                            onCheckedChange = {
                                onEvent(
                                    AddEditProposalEvent.UpdateProposalFields(
                                        proposal = proposal.copy(
                                            hidePrices = it,
                                        ),
                                    ),
                                )
                            },
                            modifier = Modifier.focusProperties { canFocus = false }
                                .align(Alignment.CenterVertically),
                        )

                        Spacer(modifier = Modifier.width(1.spacing))

                        Text(
                            text = "Hide prices",
                            style = MaterialTheme.esTypography.p1Regular16,
                            color = MaterialTheme.esColorScheme.textPrimary.copy(if (hidePricesEnabled) 1f else 0.5f),
//                            modifier = Modifier.opacity(if (hidePricesEnabled) 1f else 0.5f),
                        )
                    }

                    Spacer(modifier = Modifier.height(1.5.spacing))

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        EsPrimaryCheckBox(
                            checked = proposal.showsTotalOnly ?: false,
                            enabled = state.isEnabled,
                            onCheckedChange = { newShowsTotalOnlyValue ->
                                onEvent(
                                    AddEditProposalEvent.UpdateProposalFields(
                                        proposal = proposal.copy(
                                            showsTotalOnly = newShowsTotalOnlyValue,
                                            hidePrices = if (newShowsTotalOnlyValue) false else proposal.hidePrices,
                                        ),
                                    ),
                                )
                            },
                            modifier = Modifier
                                .focusProperties { canFocus = false }
                                .align(Alignment.CenterVertically),
                        )

                        Spacer(modifier = Modifier.width(1.spacing))

                        Text(
                            text = "Show total only",
                            style = MaterialTheme.esTypography.p1Regular16,
                            color = MaterialTheme.esColorScheme.textPrimary,
                        )
                    }

                    Spacer(modifier = Modifier.height(1.5.spacing))

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        EsPrimaryCheckBox(
                            checked = proposal.hideBranding ?: false,
                            enabled = state.isEnabled,
                            onCheckedChange = {
                                onEvent(
                                    AddEditProposalEvent.UpdateProposalFields(
                                        proposal = proposal.copy(
                                            hideBranding = it,
                                        ),
                                    ),
                                )
                            },
                            modifier = Modifier
                                .focusProperties { canFocus = false }
                                .align(Alignment.CenterVertically),
                        )

                        Spacer(modifier = Modifier.width(1.spacing))

                        Text(
                            text = "Hide branding",
                            style = MaterialTheme.esTypography.p1Regular16,
                            color = MaterialTheme.esColorScheme.textPrimary,
                        )
                    }
                }

                Spacer(modifier = Modifier.height(3.spacing))

                Box(
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Column(
                        horizontalAlignment = Alignment.End,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(
                                horizontal = 2.spacing,
                                vertical = 1.5f.spacing,
                            )
                            .align(Alignment.CenterEnd),
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Text(
                                text = "Overall price",
                                color = MaterialTheme.esColorScheme.textPrimary,
                                style = MaterialTheme.esTypography.p2Medium14,
                            )
                            Spacer(modifier = Modifier.width(1.5.spacing))
                            Text(
                                text = "${CurrencyConfig.defaultCurrencySymbol}${formatIntMoney(priceIntSum)}",
                                color = MaterialTheme.esColorScheme.textPrimary,
                                style = MaterialTheme.esTypography.h4SemiBold20,
                                textAlign = TextAlign.End,
                                maxLines = 1,
                            )
                        }

                        Spacer(modifier = Modifier.height(0.5.spacing))

                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Text(
                                text = "Commission",
                                color = MaterialTheme.esColorScheme.textPrimary,
                                style = MaterialTheme.esTypography.p2Regular14,
                            )
                            Spacer(modifier = Modifier.width(1.5.spacing))
                            Text(
                                text = "${CurrencyConfig.defaultCurrencySymbol}${formatIntMoney(commissionIntSum)}",
                                color = MaterialTheme.esColorScheme.textPrimary,
                                style = MaterialTheme.esTypography.p1Medium16,
                                textAlign = TextAlign.End,
                                maxLines = 1,
                            )
                        }
                    }

                    Column(
                        modifier = Modifier
                            .align(Alignment.CenterStart),
                    ) {
                        EsInputLabel(
                            label = "Cover Image",
                            modifier = Modifier,
                        )

                        Spacer(
                            modifier = Modifier.height(.5f.spacing),
                        )

                        state.fileState.getAllFile.data?.firstOrNull()?.let { file ->
                            UnsplashImage(
                                url = file.url,
                                enabled = state.isEnabled,
                                selectable = false,
                                imageSize = DpSize(264.dp, 160.dp),
                                onDelete = {
                                    onEvent(AddEditProposalEvent.DeleteCoverImage)
                                },
                                onClick = {
                                    isFileViewerOpened = true
                                    fileUrl = file.url
                                },
                            )
                        } ?: Box {
                            Row {
                                EsMediumTintedButton(
                                    text = "Get from Unsplash",
                                    enabled = state.isEnabled,
                                    onClick = {
                                        openUnsplashDialog = true
                                    },
                                )

                                Spacer(modifier = Modifier.width(1.spacing))

                                EsMediumSecondaryButton(
                                    text = "Odia Gallery",
                                    enabled = state.isEnabled,
                                    onClick = {
                                        openEssntlGalleryDialog = true
                                    },
                                )
                            }

                            EssntlGallery(
                                entity = EssntlGalleryState.Entity.PROPOSAL_COVER,
                                isOpen = openEssntlGalleryDialog,
                                onDismissRequest = {
                                    openEssntlGalleryDialog = false
                                },
                                multipleSelect = false,
                                onAddImages = {
                                    val image = it.firstOrNull() ?: return@EssntlGallery
                                    onEvent(AddEditProposalEvent.AddCoverImage(image))
                                },
                            )

                            UnsplashPopup(
                                isOpen = openUnsplashDialog,
                                onDismissRequest = {
                                    openUnsplashDialog = false
                                },
                                multipleSelect = false,
                                onAddImages = { urls, keyword ->
                                    val imageUrl = urls.firstOrNull() ?: return@UnsplashPopup
                                    onEvent(
                                        AddEditProposalEvent.AddCoverImage(
                                            FileModel.empty.copy(
                                                url = imageUrl,
                                                keywords = listOf(keyword),
                                            ),
                                        ),
                                    )
                                },
                            )
                        }
                    }
                }

                FileViewer(
                    fileUrl = fileUrl,
                    isDialogOpened = isFileViewerOpened,
                    onDismissRequest = {
                        isFileViewerOpened = false
                        fileUrl = ""
                    },
                )
            }
        else
            BaseInformationSummary(
                state = state,
                onEvent = onEvent,
                onNavigation = onNavigation,
                selectedAreaList = selectedAreaList,
                onEdit = { editable = !editable },
            )
    }
}